import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { TranslationsContext } from "../../utils/TranslationsContext";
import { icons, images } from "../../constants";
import AccreditationButton from "../../components/AccreditationButton/AccreditationButton";
import "./style/style.css";

const NotFoundPage = () => {
  const { t } = useContext(TranslationsContext);
  const navigate = useNavigate();

  return (
    <div className="flex-direction-column items-center justify-center gap-24 width-100 not-found-page">
      <img src={images.logo} alt="Logo" className="flag" />
      <img src={icons.error} alt="" className="not-found-icon" />
      <div className="flex-direction-column items-center gap-8 text-center">
        <h1 className="font-36 inria-sans-300 login-title">
          {t("UI_PAGE_NOT_FOUND_TITLE")}
        </h1>
        <p className="font-12 inria-sans-400 not-found-subtitle">
          {t("UI_PAGE_NOT_FOUND_SUBTITLE")}
        </p>
      </div>
      <AccreditationButton
        type="save"
        title={t("UI_BACK_TO_HOME")}
        className="not-found-back-btn"
        onClick={() => navigate("/")}
      />
    </div>
  );
};

export default NotFoundPage;
